import {QuestionTypeConfigProps} from 'organization/Event/Form/dialog/Form/QuestionTypeConfig'
import React from 'react'
import CharacterLimitInputs from 'organization/Event/Form/dialog/Form/CharacterLimitInputs'

export function LongAnswerTextConfig(props: QuestionTypeConfigProps) {
  return <CharacterLimitInputs {...props} />
}
